import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { useRef } from "react";
import toast, { Toaster } from "react-hot-toast";

export default function AddCategory() {
  const navigate = useNavigate();
  const { id } = useParams();

  const isEdit = Boolean(id);
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    // name: "",
    imageUrl: "",
    description: "",
    category: "",
  });

  //  LOAD CATEGORY DATA WHEN EDIT
  useEffect(() => {
    if (isEdit) {
      axios
        .get(`https://api.livestockify.com/api/admin/product-category/${id}`)
        .then((res) => {
          const {  imageUrl, description, category } = res.data;
          setFormData({  imageUrl, description, category });
        });
    }
  }, [id, isEdit]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!formData.imageUrl) {
      toast.error("Image URL is required");
      return;
    }

    if (!formData.description) {
      toast.error("Description is required");
      return;
    }

    if (!formData.category) {
      toast.error("Category is required");
      return;
    }

    try {
      if (isEdit) {
        await axios.put(
          `https://api.livestockify.com/api/admin/product-category/${id}`,
          formData
        );
      } else {
        await axios.post(
          "https://api.livestockify.com/api/admin/product-category",
          formData
        );
      }

      navigate(-1);
    } catch (error) {
      toast.error("Something went wrong");
      console.error(error);
    }
  };

  return (
    <div className="flex min-h-screen mx-auto bg-gray-100">
      <Sidebar />

      <Toaster position="top-right" />

      <div className="flex-1 p-6 bg-white rounded-l-2xl">
        <h1 className="text-green-700 font-semibold mb-6">
          {isEdit ? "Edit Category" : "Add Category"}
        </h1>

        <div className="max-w-4xl mt-10 space-y-4">
          {/* Name */}

          {/* Image URL */}
         <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-4 md:gap-6">
  <label className="text-sm font-medium text-center md:text-right">
    Image URL
  </label>

  <div className="md:col-span-2 flex gap-2">
              <input
                name="imageUrl"
                value={formData.imageUrl}
                onChange={handleChange}
                // onClick={() => fileInputRef.current.click()}
                placeholder="Enter Image URL"
                className="flex-1 border px-3 py-2 rounded-md text-sm cursor-pointer"
              />
            </div>
          </div>

          {/* Description */}
         <div className="grid grid-cols-1 md:grid-cols-3 items-start gap-4 md:gap-6">
  <label className="text-sm font-medium text-center md:text-right">
    Description
  </label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Enter Description"
              className="md:col-span-2 border px-3 py-2 rounded-md text-sm h-28"
            />
          </div>

          {/* Category */}
         <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-4 md:gap-6">
  <label className="text-sm font-medium text-center md:text-right">
    Category
  </label>
            <input
              name="category"
              value={formData.category}
              onChange={handleChange}
              placeholder="Enter Category"
              className="md:col-span-2 border px-3 py-2 rounded-md text-sm"
            />
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-4 pt-6">
            <button
              onClick={() => navigate(-1)}
              className="border px-6 py-2 rounded-md text-sm"
            >
              Cancel
            </button>

            {/* 🔥 BUTTON TEXT CHANGES */}
            <button
              onClick={handleSubmit}
              className="bg-green-500 text-white px-6 py-2 rounded-md text-sm"
            >
              {isEdit ? "Update" : "Add"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
